t = require('views/internal/teacup-with-helpers')('board_header_permissions')

module.exports = t.renderable ({ permIconClass, permText })->
  t.span { class: t.classify('board-header-btn-icon': true, 'icon-sm': true, "icon-#{permIconClass}": true) }
  t.span '.board-header-btn-text', ->
    t.text permText



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_header_permissions.coffee